import React, { useState } from "react";
import { Formik } from "formik";
import { addNewAddress, deleteAddress, editAddress } from "../../../../api";
import phones from "../../../../static/phones.json";
import { initialValues, validate } from "./initForm";
import { validateNumber } from "../../../../utils/validations";
import { useDispatch } from "react-redux";
import { authActions } from "../../../../actions/auth";

import TextFieldV3 from "../../../Inputs/TextFieldv3";
import SelectTypeAddress from "../../../Inputs/SelectTypeAddress";
import Select from "../../../Inputs/Select";
import SelectV2 from "../../../Inputs/Select";
import Button from "../../../Button";
import styles from "./EditShippingModal.module.scss";
import TextFieldv3 from "../../../Inputs/TextFieldv3";
import homeIcon from "../../../../static/icons/house-two.svg";
import closeIcon from "../../../../static/icons/close.svg";
import ConfirmShippingDeleteModal from "../../ConfirmShippingDeleteModal";
const UploadShippingModal = ({
  onClose,
  submitButtonText = "Save",
  submitButtonColor = "blue",
  isCancelButtonNeed = true,
  onUpdateAddresses,
  addressInfo,
}) => {
  const [phoneCodes, setPhoneCodes] = useState(phones);
  const [cities, setCities] = useState([]);
  const reduxDispatch = useDispatch();
  const [isConfirmOpen, setIsConfirmOpen] = useState(false);

  const searchCountryCode = (query) => {
    setPhoneCodes(phones.filter((item) => item.value.includes(query)));
  };

  const editExistingAddress = (data) => {
    let city_place_id = "";

    if (cities.length > 0) {
      data.city == ""
        ? ""
        : (city_place_id = cities.find(({ value }) => value === data.city)
            .shortValue);
    } else {
      delete data.city;
    }

    const totalAddressInfo = {
      ...data,
      phone: `${data.countryCode.trim()}${data.phoneNumber.trim()}`,
      city_place_id,
    };
    console.log("adressInfo", addressInfo);

    console.log(totalAddressInfo["address"] == "");
    totalAddressInfo["id"] = addressInfo["id"];

    totalAddressInfo["doorbell"] = addressInfo["doorbell"];
    totalAddressInfo["address"] == "" &&
      (totalAddressInfo["address"] = addressInfo["address"]);

    totalAddressInfo["city_place_id"] == "" &&
      (totalAddressInfo["city_place_id"] = addressInfo["city"]["place_id"]);
    totalAddressInfo["client_full_name"] == "" &&
      (totalAddressInfo["client_full_name"] = addressInfo["client_full_name"]);
    totalAddressInfo["countryCode"] == "" &&
      (totalAddressInfo["countryCode"] = addressInfo["phone"]["dial_code"]);
    totalAddressInfo["phoneNumber"] == "" &&
      (totalAddressInfo["phoneNumber"] = addressInfo["phone"]["phone"]);

    totalAddressInfo["postal_code"] == "" &&
      (totalAddressInfo["postal_code"] = addressInfo["postal_code"]);

    console.log("total", totalAddressInfo);

    onClose();

    reduxDispatch(authActions.startLoading());

    editAddress(totalAddressInfo).then(({ response }) => {
      if (response) {
        reduxDispatch(authActions.finishLoading());
        onUpdateAddresses();
      }
    });
  };

  const onDelete = (data) => {
    onClose();
    deleteAddress(data).then(({ response }) => {
      if (response) {
        reduxDispatch(authActions.finishLoading());
        onUpdateAddresses();
      }
    });
  };

  return (
    <div className={styles.Modal}>
      {isConfirmOpen && (
        <ConfirmShippingDeleteModal
          isOpened={isConfirmOpen}
          onClose={()=>{
            onDelete(addressInfo);
          }}
          onModalClose={onClose}
        />
      )}
      <Formik initialValues={initialValues} onSubmit={editExistingAddress}>
        {({ handleSubmit, errors, touched }) => {
          const isNameError =
            errors.client_full_name && touched.client_full_name;
          const isPhoneError = errors.phoneNumber && touched.phoneNumber;
          return (
            <form onSubmit={handleSubmit}>
              <div className={styles.header}>
                <img src={closeIcon} width={15} onClick={onClose} />
                <div className={styles.centerIcons}>
                  <img width={20} src={homeIcon} />
                  <span>Edit Address</span>
                </div>
                <div></div>
              </div>
              <div className={styles.home}>
                <SelectTypeAddress
                  options={[{ value: "Home" }, { value: "Work" }]}
                  name="alias"
                  type="text"
                  placeholder="Home"
                  variant="underline"
                />
              </div>

              <TextFieldV3
                name="client_full_name"
                type="text"
                label="Receiver Name"
                placeholder={addressInfo.client_full_name}
                variant="withborder"
              />
              <p className={styles.phoneNumberLabel}>Phone number</p>
              <div className={styles.phoneLine}>
                <div className={styles.countryCode}>
                  <SelectV2
                    options={phoneCodes}
                    name="countryCode"
                    label="Phone number"
                    type="text"
                    placeholder={addressInfo.phone["dial_code"]}
                    variant="outline"
                    isAutocomplete
                    onAutocomplete={(query) => searchCountryCode(query)}
                    validateSymbols={(val) => validateNumber(val, 10)}
                  />
                </div>
                <div className={styles.phoneNumber}>
                  <TextFieldV3
                    name="phoneNumber"
                    type="text"
                    placeholder={addressInfo.phone["phone"]}
                    variant="underline"
                    validateSymbols={(val) => validateNumber(val)}
                  />
                </div>
              </div>
              <div className={styles.Address}>
                <TextFieldv3
                  name="address"
                  type="text"
                  label="Address"
                  variant="underline"
                  placeholder={addressInfo.address}
                />
              </div>
              <div className={styles.cityField}>
                <Select
                  isAutocomplete
                  name="city"
                  variant="outline"
                  options={cities}
                  isTypeAndDropdown
                  setCity={setCities}
                  placeholder={addressInfo.city["name"]}
                />
              </div>
              <div className={styles.zipCode}>
                <TextFieldV3
                  name="postal_code"
                  type="text"
                  label="Zip code (if any)"
                  variant="underline"
                  placeholder={addressInfo.postal_code}
                />
              </div>

              <div className={styles.note}>
                <TextFieldV3
                  huge="true"
                  name="notes"
                  type="text"
                  label="Notes for courier"
                  variant="underline"
                  placeholder={addressInfo.notes}
                />
              </div>
              <div className={styles.buttons}>
                <Button
                  className={styles.submit}
                  type="submit"
                  size="large"
                  color={submitButtonColor}
                >
                  {submitButtonText}
                </Button>
                {isCancelButtonNeed && (
                  <Button
                    type="button"
                    size="large"
                    color="monochromatic"
                    onClick={() => {
                      setIsConfirmOpen(true);
                    }}
                    
                    className={styles.cancel}
                  >
                    DELETE
                  </Button>
                )}
              </div>
            </form>
          );
        }}
      </Formik>
    </div>
  );
};

export default UploadShippingModal;
